var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"statv_container statv_page_bg",attrs:{"id":"scheduleView"}},[_c('DateView')],1)}
var staticRenderFns = []

export { render, staticRenderFns }